export default "__VITE_ASSET__czWqtWbx__"